import React from 'react'
import styled from 'styled-components'

const Checkbox = ({ className, value, onChange }) => {
  return (
    <label className={className}>
      <input
        type='checkbox'
        onChange={(_value) => onChange(value)}
        checked={value}
      />
      <span />
    </label>
  )
}

const CheckboxWithStyles = styled(Checkbox)`
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 21px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    
    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    
    span {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #eee;
    }
    
    &:hover input ~ span {
        background-color: #ccc;
        transition: all 0.3s ease;
    }
    
    input:checked ~ span {
        background-color: #2E84C6;
    }
    
    span:after {
        content: "";
        position: absolute;
        display: none;
    }
    
    input:checked ~ span:after {
        display: block;
    }
    
    span:after {
        left: 7px;
        top: 4px;
        width: 4px;
        height: 7px;
        border: solid #FFF;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
`

export default CheckboxWithStyles



// WEBPACK FOOTER //
// ./src/components/checkbox/checkbox.component.js